import { HowActiveReferralModal } from '@features/teacher/how-active-referral'
import { HowWorkReferralModal } from '@features/teacher/how-work-referral'
import { ProgressReferralModal } from '@features/teacher/progress-info-modal'
import React from 'react'

export const ReferralModals = () => <>
	<ProgressReferralModal/>
	<HowWorkReferralModal/>
	<HowActiveReferralModal/>
</>
